import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { BookCallProvider } from "@/components/BookCallContext";
import BookCallModal from "@/components/BookCallModal";
import ChatWidget from "@/components/ChatWidget";
import AgentFloatButton from "@/components/AgentFloatButton";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import UseCasesRouter from "@/pages/UseCasesRouter";
import Technology from "@/pages/Technology";
import PracticeDetail from "@/pages/PracticeDetail";
import ProductDetail from "@/pages/ProductDetail";
import IndustryDetail from "@/pages/IndustryDetail";
import About from "@/pages/About";
import { Navigate } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
    return (
        <HelmetProvider>
            <div className="App">
                <BrowserRouter>
                    <BookCallProvider>
                        <ScrollToTop />
                        <Navigation />
                        <main>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/products" element={<Navigate to="/products/kyro-engage" replace />} />
                                <Route path="/products/:id" element={<ProductDetail />} />
                                <Route path="/practices" element={<Navigate to="/practices/customer-experience" replace />} />
                                <Route path="/practices/:id" element={<PracticeDetail />} />
                                <Route path="/industries" element={<Navigate to="/industries/travel" replace />} />
                                <Route path="/industries/:id" element={<IndustryDetail />} />
                                <Route path="/use-cases" element={<Navigate to="/use-cases/listen" replace />} />
                                <Route path="/use-cases/:id" element={<UseCasesRouter />} />
                                <Route path="/technology" element={<Technology />} />
                                <Route path="/about" element={<About />} />
                            </Routes>
                        </main>
                        <Footer />
                        <BookCallModal />
                        <AgentFloatButton />
                        <ChatWidget />
                    </BookCallProvider>
                </BrowserRouter>
                <Toaster position="bottom-right" />
            </div>
        </HelmetProvider>
    );
}

export default App;
